import React from "react";
import SlickSlider from "react-slick";

// Unwrap CommonJS/ESM interop if needed
const ResolvedSlider: any = (SlickSlider as any)?.default || SlickSlider;

export const Slider: React.FC<any> = (props) => {
  const Component = ResolvedSlider;
  return <Component {...props} />;
};

export default Slider;
